import { Service } from '@roc/feature-app-core';

const url = {
  GENERATE_NOTE_ALLONGE: '/api/v1/loan/splsigning/generateNoteAllongeDocument',
  GENERATE_ASSIGNMENT_CONVEYANCE: '/api/v1/loan/splsigning/generateAssignmentAndConveyanceDocument',
  VALIDATE_SIGNING_DOCUMENT: '/api/v1/loan/splsigning/validateSigningDocument',
};

export class DocumentSigningService extends Service {
  generateNoteAllongeDocument(data) {
    return this.post(url.GENERATE_NOTE_ALLONGE, data);
  }

  generateAssignmentAndConveyanceDocument(data) {
    return this.post(url.GENERATE_ASSIGNMENT_CONVEYANCE, data);
  }

  validateSigningDocument(loanId) {
    return this.get(`${url.VALIDATE_SIGNING_DOCUMENT}?loanId=${loanId}`);
  }
}